
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '@/components/ui/tabs';
import { RechargesTab } from './tabs/RechargesTab';
import { SelectionsTab } from './tabs/SelectionsTab';
import { TransfersTab } from './tabs/TransfersTab';

interface HistoryTabsProps {
  isLoading: boolean;
  date?: Date;
  selections: any[];
  transfers: any[];
  recharges: any[];
}

export const HistoryTabs: React.FC<HistoryTabsProps> = ({
  isLoading,
  date,
  selections,
  transfers,
  recharges
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <Tabs defaultValue="recharges" className="w-full h-full flex flex-col">
      <TabsList className="grid grid-cols-3 w-full flex-shrink-0">
        <TabsTrigger value="recharges">{t('history.tabs.recharges')}</TabsTrigger>
        <TabsTrigger value="selections">{t('history.tabs.plans')}</TabsTrigger>
        <TabsTrigger value="transfers">{t('history.tabs.transfers')}</TabsTrigger>
      </TabsList>
      
      <div className="flex-grow overflow-y-auto mt-4">
        <TabsContent value="recharges" className="mt-0 h-full">
          <RechargesTab recharges={recharges} date={date} />
        </TabsContent>
        
        <TabsContent value="selections" className="mt-0 h-full">
          <SelectionsTab selections={selections} date={date} />
        </TabsContent>
        
        <TabsContent value="transfers" className="mt-0 h-full">
          <TransfersTab transfers={transfers} date={date} />
        </TabsContent>
      </div>
    </Tabs>
  );
};
